/** FA catalog — FE-3 (copy carried/adapted from the approved handoff FA text). */
export const patientsFa: Record<string, string> = {
  'pt.title': 'مراجعان',
  'pt.sub':
    'پیداکردن، دیدن، ویرایش و تکمیل پرونده‌ها. نوبتِ تماسِ اول از تقویم شروع می‌شود، نه از اینجا.',
  'pt.new': 'مراجع تازه',
  'pt.searchPh': 'جستجوی شماره پرونده، نام یا موبایل',
  'pt.colPatient': 'مراجع',
  'pt.colStatus': 'وضعیت',
  'pt.colContact': 'تماس',
  'pt.colRecord': 'شماره پرونده',
  'pt.colAge': 'سن',
  'pt.colCaregiver': 'همراه',
  'pt.ageShort': '{n, number} سال',
  'pt.sortBy': 'مرتب‌سازی بر اساس {col}',
  'pt.sortedAsc': 'مرتب شده صعودی',
  'pt.sortedDesc': 'مرتب شده نزولی',
  'pt.filterBy': 'فیلتر بر اساس {col}',
  'pt.apply': 'اعمال',
  'pt.activeFilters': 'فیلترهای فعال',
  'pt.removeFilter': 'حذف {label}',
  'pt.clearAll': 'پاک کردن همه',
  'pt.fRecord': 'شماره پرونده',
  'pt.fRecordHelp': 'شماره پرونده دقیق؛ مهمان‌ها شماره پرونده ندارند.',
  'pt.fAgeMin': 'از سن',
  'pt.fAgeMax': 'تا سن',
  'pt.fAgeHelp':
    'سال کامل بر اساس تاریخ امروز، از تاریخ تولد. مهمانی که تاریخ تولدش ثبت‌نشده، هیچ‌وقت با فیلتر سن پیدا نمی‌شود.',
  'pt.fCaregiver': 'نام همراه',
  'pt.fPhone': 'شماره تلفن',
  'pt.fPhoneHelp': 'هر یک از شماره‌های خودِ پرونده — موبایل تماس، منزل یا اضافی.',
  'pt.fStatus': 'وضعیت',
  'pt.fStatusAll': 'همه',
  'pt.fStatusPatient': 'مراجعان',
  'pt.fStatusGuest': 'مهمان‌ها',
  'pt.chipRecord': 'پرونده {n}',
  'pt.chipAge': 'سن {min}–{max}',
  'pt.chipAgeMin': 'سن {n}+',
  'pt.chipAgeMax': 'سن تا {n}',
  'pt.chipCaregiver': 'همراه: {q}',
  'pt.chipPhone': 'تلفن: {q}',
  'pt.chipGuest': 'فقط مهمان‌ها',
  'pt.chipPatient': 'فقط مراجعان',
  'pt.colAutism': 'اوتیسم',
  'pt.autismTag': 'اوتیسم',
  'pt.fAutism': 'اوتیسم',
  'pt.fAutismAll': 'همه',
  'pt.fAutismYes': 'به‌عنوان اوتیستیک شناسایی‌شده',
  'pt.chipAutism': 'به‌عنوان اوتیستیک شناسایی‌شده',
  'pt.statePatient': 'مراجع',
  'pt.stateGuest': 'مهمان — در انتظار اولین ویزیت',
  'pt.stateGuestShort': 'مهمان',
  'pt.stateMerged': 'ادغام شده در پرونده دیگر',
  'pt.statePatientNo': 'مراجع · پرونده {n}',
  'pt.age': '{n, plural, one {# ساله} other {# ساله}}',
  'pt.emptyTitle': 'هنوز پرونده‌ای نیست',
  'pt.emptyBody':
    'پرونده‌ها معمولاً هنگام گرفتن نوبت اول، از تقویم ساخته می‌شوند. «مراجع تازه» برای وقتی است که لازم باشد پرونده‌ای را مستقیم اضافه کنید.',
  'pt.twoStates':
    '«مهمان» یعنی هویتی قابل‌نوبت‌دهی که ثبت‌نامش ناتمام است — فقط نام و شمارهٔ تماس، بدون شمارهٔ پرونده و بدون کار درمانی. «مراجع» یعنی ثبت‌نام کامل شده: سامانهٔ مرکز شمارهٔ پرونده را داده و معارفه، ارزیابی، بسته‌ها و جلسه‌ها باز است.',
  'pt.phoneSearchNeedsContacts':
    'جست‌وجوی شماره این‌جا با شمارهٔ تماسِ خودِ پرونده می‌گردد. شماره‌های همراهان از جست‌وجوی نوبت و با دسترسی «تماس‌ها» پیدا می‌شود.',
  'pt.matchedCaregiver':
    'از راه شمارهٔ یکی از همراهان پیدا شد — شمارهٔ تماس خودِ پرونده متفاوت است.',
  'pt.matchedFirstName': 'با نام کوچک پیدا شد.',
  'pt.gate.notRegistered':
    'سامانه مرکز نپذیرفت: این پرونده مهمان است و اول باید ثبت‌نامش کامل شود. چیزی ساخته نشد — ثبت‌نام را از خود پرونده کامل کنید و دوباره تلاش کنید.',
  'pt.gate.merged':
    'سامانه مرکز نپذیرفت: این هویت در پرونده دیگری ادغام شده است. پرونده باقی‌مانده را باز کنید و همان‌جا ادامه دهید.',
  'pt.errForbidden':
    'سامانه مرکز نپذیرفت: این کار جزو نقش شما نیست. کسی که نقشش مدیریت مراجع را دارد می‌تواند انجامش دهد — هیچ‌چیز از آنچه نوشتید از بین نرفت.',

  'ptForm.newTitle': 'مراجع تازه',
  'ptForm.newSub':
    'یک پرونده، یک فرم. نام و یک شمارهٔ تماس برای ذخیره کافی است — این «مهمان» است و همین حالا نوبت می‌گیرد. جنسیت، تاریخ تولد و نشانی را اضافه کنید تا پرونده در همین مرحله ثبت‌نام شود.',
  'ptForm.editTitle': 'ویرایش پرونده',
  'ptForm.completeTitle': 'تکمیل ثبت‌نام',
  'ptForm.completeSub':
    'عمل ثبت‌نام: جنسیت، تاریخ تولد و نشانی پرونده را کامل می‌کنند، سامانه مرکز شماره پرونده را می‌دهد و کار بالینی باز می‌شود. نام همان‌طور که ذخیره‌شده بود می‌ماند.',
  'ptForm.contactMobile': 'موبایل تماس اصلی',
  'ptForm.contactMobileHelp':
    'شمارهٔ تماس اصلی پرونده — برای کودک معمولاً شمارهٔ پدر، مادر یا همراه است. همراهان شمارهٔ خودشان را هم روی پرونده دارند.',
  'ptForm.mobileTooShort': 'این هنوز شبیه شماره تلفن نیست — دست‌کم ۵ رقم وارد کنید.',
  'ptForm.toRegister': 'برای ثبت‌نام',
  'ptForm.registerCta': 'ثبت مراجع',
  'ptForm.saveGuestCta': 'ذخیره به‌عنوان مهمان',
  'ptForm.completeCta': 'تکمیل ثبت‌نام',
  'ptForm.registrationReady':
    'هر چه برای ثبت‌نام لازم است این‌جاست — با ذخیره، پرونده ثبت می‌شود و شماره پرونده‌اش تعیین می‌شود.',
  'ptForm.registrationGaps':
    'برای ثبت‌نام هنوز لازم است: {fields}. ذخیره بدون این‌ها «مهمان» می‌ماند — قابل‌نوبت‌دهی، هنوز پروندهٔ درمانی نیست.',
  'ptForm.registrationIncomplete':
    'سامانه مرکز برای کامل کردن، همه اطلاعات ثبت‌نام را لازم دارد. کم است:',
  'ptForm.missingField': 'برای ثبت‌نام لازم است',
  'ptForm.alreadyRegistered': 'این پرونده از قبل ثبت‌شده است',
  'ptForm.alreadyRegisteredBody':
    'ثبت‌نام قبلا کامل‌شده و شماره پرونده تعیین شده است. اطلاعات جمعیتی از خود پرونده ویرایش می‌شود.',
  'ptForm.absorbOverlap':
    'مهمان و پروندهٔ موجود نوبت‌هایی دارند که از نظر زمانی روی هم می‌افتند، پس سامانهٔ مرکز یکی‌کردن‌شان را نپذیرفت. اول نوبت‌ها را درست کنید، بعد دوباره تلاش کنید.',
  'ptForm.caregiverRequiredAtRegistration':
    'در این سن، هنگام تکمیل ثبت‌نام همراه لازم می‌شود. می‌شود حالا یا همان موقع اضافه‌اش کرد.',
  'ptForm.first': 'نام',
  'ptForm.last': 'نام خانوادگی',
  'ptForm.gender': 'جنسیت',
  'pt.gender.male': 'مرد',
  'pt.gender.female': 'زن',
  'pt.gender.unknown': 'نامشخص',
  'ptForm.genderRecorded': '{value} (همان‌طور که ثبت‌شده)',
  'ptForm.dob': 'تاریخ تولد',
  'ptForm.dobHelp': 'با تقویم مرکز انتخاب می‌شود — هیچ‌وقت متن آزاد نیست.',
  'ptForm.address': 'نشانی',
  'ptForm.nationalId': 'کد ملی',
  'ptForm.referral': 'منبع ارجاع',
  'ptForm.referralHelp': 'متن آزاد.',
  'ptForm.notes': 'یادداشت‌ها',
  'ptForm.autism': 'توسط مرکز به‌عنوان اوتیستیک شناسایی‌شده',
  'ptForm.autismHelp':
    'شناسایی فعلی مرکز. بعدا قابل‌تغییر است؛ هر تغییر در تاریخچه پرونده می‌ماند.',
  'ptForm.autismYes': 'بله',
  'ptForm.autismNo': 'خیر',
  'ptForm.save': 'ذخیره پرونده',
  'ptForm.caregiverTitle': 'ولی / همراه',
  'ptForm.caregiverAlways':
    'در هر سنی ممکن است لازم باشد — همراه در هر سنی می‌تواند مهم باشد. در ۱۸ سال و کمتر، یا ۶۵ سال و بیشتر الزامی است.',
  'ptForm.caregiverRequiredNow': 'در این سن، پیش از ذخیرهٔ پرونده یک همراه لازم است.',
  'ptForm.caregiverOptionalNow': 'در این سن، همراه اختیاری است.',
  'ptForm.caregiverSatisfied':
    'این پرونده از قبل همراه دارد و نیازِ این سن برآورده است. فیلدهای پایین را فقط برای افزودن نفر دیگری پر کنید.',
  'ptForm.caregiverOnRecord': 'روی پرونده: {list}.',
  'ptForm.caregiverGap': 'ولی / همراه',
  'ptForm.registrationNeedsCaregiver':
    'همه‌چیز آماده است جز یک مورد — در این سن، پیش از ثبت‌نام یک همراه لازم است. پایین صفحه اضافه کنید.',
  'ptForm.cgName': 'نام کامل',
  'ptForm.cgRelationship': 'نسبت',
  'ptForm.cgOther': 'نسبت (به زبان خودشان)',
  'ptForm.cgMobile': 'شماره تماس',
  'ptForm.cgNotes': 'یادداشت‌ها',
  'ptForm.cgContactFirst': 'اول با این شخص تماس بگیرید',
  'ptForm.cgAccompanies': 'معمولا همراه مراجع است',
  'ptForm.rel.mother': 'مادر',
  'ptForm.rel.father': 'پدر',
  'ptForm.rel.grandparent': 'پدربزرگ یا مادربزرگ',
  'ptForm.rel.legal_guardian': 'سرپرست قانونی',
  'ptForm.rel.nanny_caretaker': 'پرستار / مراقب',
  'ptForm.rel.other': 'دیگر',
  'ptForm.caregiverRequiredError':
    'سامانهٔ مرکز در این سن (۱۸سال‌به‌پایین یا ۶۵سال‌به‌بالا) دست‌کم یک همراه می‌خواهد. چیزی از نوشته‌هایتان از دست نرفت.',

  'dup.title': 'شبیه پرونده‌ای است که دارید',
  'dup.sub': 'پیش از ساختن پرونده جدید، یک نگاه بیندازید. هیچ‌چیزی خودبه‌خود ادغام نمی‌شود.',
  'dup.typed': 'آنچه همین حالا نوشتید',
  'dup.existing': 'پرونده‌ای که از قبل وجود دارد',
  'dup.signals': 'چرا این مطابقت پیدا کرد',
  'dup.same': 'همان شخص — از پرونده موجود استفاده کن',
  'dup.different': 'شخص دیگری — هر دو بمانند',
  'dup.absorb': 'همان شخص — این مهمان را در پرونده ادغام کن',
  'dup.absorbNote':
    'نوبت‌های مهمان به پروندهٔ موجود می‌رود؛ چیزی حذف نمی‌شود. با نام شما ثبت می‌شود.',
  'dup.differentNote':
    'نگه‌داشتن هر دو با نام شما ثبت می‌شود — تنها راه ادامه بعد از یک تطبیق علامت‌خورده است.',
  'dup.needResolve':
    'تایید این‌که شخص دیگری است به مجوز حل تکراری نیاز دارد. از مدیر مرکز بخواهید این ثبت‌نام را تمام کند.',
  'dup.mergeNote':
    '«همان شخص» یعنی با پروندهٔ موجود ادامه می‌دهید و چیز تازه‌ای ساخته نمی‌شود. جا دادن مهمانِ ذخیره‌شده در پروندهٔ هم‌خوانش نوبت‌هایش را نگه می‌دارد. یکی‌کردن دو پروندهٔ جاافتاده در این نسخه وجود ندارد.',
  'dup.askCaller': 'اگر مطمئن نیستید، ساده از تماس‌گیرنده بپرسید آیا قبلا تماس گرفته است یا نه.',
  // ZOY-640: the same panel on an EDIT that changed an identity field.
  'dup.subEdit':
    'پیش از ذخیره این تغییر، یک نگاه بیندازید. هیچ‌چیزی خودبه‌خود ادغام نمی‌شود — و هنوز چیزی ذخیره نشده است.',
  'dup.typedEdit': 'آنچه این پرونده را به آن تغییر دادید',
  'dup.sameEdit': 'همان شخص — پرونده موجود را باز کن (این ویرایش ذخیره نمی‌شود)',
  'dup.differentNoteEdit':
    'نگه‌داشتن هر دو، این تغییر را ذخیره می‌کند و تصمیم را با نام شما ثبت می‌کند — تنها راه ادامه بعد از یک تطبیق علامت‌خورده است.',
  'dup.needResolveEdit':
    'تایید این‌که شخص دیگری است به مجوز حل تکراری نیاز دارد. از مدیر مرکز بخواهید این تغییر را ذخیره کند.',
  'dup.mergeNoteEdit':
    '«همان شخص» یعنی پروندهٔ دیگر همان است که باید استفاده شود — این ویرایش روی آن ذخیره نمی‌شود. جا دادن مهمانِ ذخیره‌شده در پروندهٔ هم‌خوانش نوبت‌هایش را نگه می‌دارد. یکی‌کردن دو پروندهٔ جاافتاده در این نسخه وجود ندارد.',

  'res.title': 'برای چه کسی؟',
  'res.sub':
    'شماره، کلید سریع هنگام تماس است؛ چند رقم یا یک نام هر دو کار می‌کنند. شماره مشترک یک مراقب ممکن است چند مراجع داشته باشد — تماس‌گیرنده لزوما خود مراجع نیست.',
  'res.searchPh': 'موبایل تماس‌گیرنده، شماره پرونده، یا یک نام…',
  'res.pick': 'نوبت برای همین نفر',
  'res.none': 'هیچ‌کدام؟',
  'res.moreDigits': 'ادامه بدهید — برای جستجوی شماره دست‌کم پنج رقم لازم است.',
  'res.needRegister': 'ساختن پرونده به مجوز ثبت مراجع نیاز دارد.',
  'res.signal.contact_mobile': 'این شماره تماس خود پرونده است',
  'res.signal.caregiver_mobile': 'شمارهٔ یکی از همراهان',
  'res.signal.name_dob': 'نام و تاریخ تولد یکسان',
  'res.signal.national_id': 'کد ملی یکسان',
  'res.newCta': 'کسی که پرونده ندارد',
  'res.noMatches':
    'پرونده‌ای پیدا نشد. تماسِ اول فقط با نام و شماره ذخیره می‌شود — یک مهمان، که همین حالا نوبت می‌گیرد.',
  'res.guestTitle': 'چه کسی مراجعه می‌کند',
  'res.guestNameHelp': 'کسی که حضور پیدا می‌کند — کودک، نه تماس‌گیرنده.',
  'res.guestPhone': 'موبایل / شماره تماس',
  'res.guestPhoneHelp':
    'از جستجو آورده شده — می‌تواند شماره یکی از والدین باشد. این شماره تماس پرونده می‌شود.',
  'res.guestCta': 'ذخیره و ادامه',
  'res.guestNote':
    'همین حالا به‌عنوان مهمان ذخیره می‌شود: قابل‌نوبت‌دهی، با ثبت‌نامِ هنوز ناتمام. جنسیت، تاریخ تولد و نشانی پیش از هر کار درمانی روی پرونده کامل می‌شود.',
  'res.hostNote':
    'این مؤلفه داخل «نوبت تازه» می‌نشیند. این صفحه پیش‌نمایش کاری آن است — انتخاب، پرونده را باز می‌کند.',

  'rec.attendingSince': 'مراجعه کننده از {date}',
  'rec.caregiver': 'ولی/همراه',
  'rec.contact': 'تماس',
  'rec.gender': 'جنسیت',
  'rec.dob': 'تولد',
  'rec.notRecorded': 'هنوز ثبت نشده',
  'rec.addressNotRecorded': 'نشانی هنوز ثبت نشده',
  'rec.completeRegistration': 'تکمیل ثبت‌نام',
  'rec.guestTitle': 'ثبت‌نام کامل نیست',
  'rec.guestBody':
    'این یک مهمان است: می‌شود نوبت گرفت، جابه‌جا کرد، لغو کرد یا غیبت زد، اما معارفه، ارزیابی، بسته‌ها و ثبت جلسه تا تکمیل ثبت‌نام و دادن شمارهٔ پرونده از سوی سامانهٔ مرکز بسته می‌ماند.',
  'rec.guestNeedsPermission': 'کامل کردنش به مجوز ثبت مراجع نیاز دارد.',
  'rec.mergedTitle': 'این هویت در پرونده دیگری ادغام شده است',
  'rec.mergedBody':
    'مهمانی بود که با مراجع موجودی هم‌خوانی داشت؛ نوبت‌هایش به آن‌جا رفت. در این صفحه کار تازه‌ای انجام نمی‌شود.',
  'rec.mergedOpen': 'باز کردن پرونده',
  'rec.sectionsNote':
    'هر بخش جداگانه بارگذاری می‌شود؛ اگر یکی در دسترس نباشد، بقیه سر جایشان می‌مانند و همان بخش دکمه تلاش مجدد نشان می‌دهد.',
  'rec.retry': 'تلاش دوباره',
  /* Patient workspace: summary, tabs, overview */
  'rec.tab.overview': 'نمای کلی',
  'rec.tab.clinical': 'بالینی',
  'rec.tab.sessions': 'جلسه‌ها',
  'rec.tab.plans': 'بسته‌ها و پرداخت‌ها',
  'rec.tab.details': 'جزئیات',
  'rec.tabsLabel': 'پرونده مراجع',
  'rec.sum.file': 'شماره پرونده',
  'rec.sum.age': 'سن',
  'rec.sum.dob': 'تاریخ تولد',
  'rec.sum.gender': 'جنسیت',
  'rec.sum.contact': 'تماس',
  'rec.sum.caregiver': 'همراه اصلی',
  'rec.sum.since': 'مراجعه کننده از',
  'rec.sum.stage': 'مرحله مراقبت',
  'rec.sum.guestFile': 'هنگام ثبت‌نام تعیین می‌شود',
  'rec.ov.nextTitle': 'این مراجع کجای مسیر است',
  'rec.ov.nextSub': 'مرحله مراقبت از سامانه مرکز، و کار بعدی.',
  'rec.ov.upcomingTitle': 'نوبت بعدی',
  'rec.ov.noUpcoming': 'چیزی برنامه‌ریزی نشده.',
  'rec.ov.lastDelivered': 'آخرین ارائه {date}',
  'rec.ov.clinicalTitle': 'وضعیت بالینی',
  'rec.ov.intakeNone': 'هنوز معارفه‌ای نیست',
  'rec.ov.assessmentNone': 'هنوز ارزیابی‌ای نیست',
  'rec.ov.assessmentSigned': 'امضا شده {date}',
  'rec.ov.instruments': '{n, plural, =0 {هیچ ابزاری} one {# اجرای ابزار} other {# اجرای ابزار}}',
  'rec.ov.plansTitle': 'بسته‌ها',
  'rec.ov.noPackages': 'هنوز بسته‌ای نیست.',
  'rec.ov.attentionTitle': 'نیازمند توجه',
  'rec.ov.unpaid': '{n, number} جلسهٔ انجام‌شده منتظر ثبت پرداخت است',
  'rec.ov.stalled': 'مراقبت متوقف به نظر می‌رسد — در برابر بسته باز، ارائه اخیری ثبت‌نشده.',
  'rec.ov.nothingAttention': 'چیزی در انتظار نیست.',
  'rec.ov.open': 'باز کردن',
  'rec.ov.caregiverTitle': 'تماس',
  'rec.ses.title': 'نوبت‌ها و جلسات',
  'rec.ses.sub': 'همهٔ نوبت‌های این پرونده و سرانجام هر کدام؛ جلسهٔ انجام‌شده صفحهٔ خودش را دارد.',
  'rec.ses.filter.upcoming': 'پیش رو',
  'rec.ses.filter.all': 'همه',
  'rec.ses.filter.delivered': 'انجام‌شده',
  'rec.ses.colWhen': 'چه زمانی',
  'rec.ses.colWhat': 'جلسه',
  'rec.ses.colState': 'نتیجه',
  'rec.ses.empty': 'هنوز نوبتی روی این پرونده نیست.',
  'rec.ses.emptyUpcoming': 'چیزی پیش رو نیست.',
  'rec.ses.sessionN': 'جلسه {n}',
  'rec.ses.voided': 'باطل‌شده',
  'rec.ses.colDay': 'روز',
  'rec.ses.routineTitle': 'برنامه منظم',
  'rec.ses.routineSub': 'از نوبت‌های هشت هفته گذشته و نوبت‌های پیش رو خوانده می‌شود.',
  'rec.ses.routineDay': '{day}s',
  'rec.ses.routineWhen': '{weekdays} {time}',
  'rec.grp.title': 'جلسه‌های گروهی',
  'rec.grp.sub':
    'همه جلسات گروهی که این مراجع در آن‌ها شرکت کرده است. هر جلسه یک اجرای مستقل با شرکت‌کنندگان خودش است؛ گزارش گروه بین همه شرکت‌کنندگان مشترک است.',
  'rec.grp.empty': 'هیچ جلسه گروهی روی این پرونده نیست.',
  'rec.grp.colReport': 'گزارش گروه',
  'rec.grp.reportView': 'دیدن گزارش',
  'rec.grp.reportWrite': 'نوشتن گزارش',
  'rec.grp.reportNone': 'هنوز گزارشی نیست',
  'rec.grp.open': 'باز کردن جلسه',
  'rec.plan.progress':
    '{delivered} از {planned} ارائه شده · {scheduled} برنامه‌ریزی‌شده · {remaining} برای برنامه‌ریزی',
  'rec.plan.overbooked':
    '{n} جلسه بیش از برنامه برنامه‌ریزی‌شده — جلسات بیش از برنامه با قیمت فهرست ارائه می‌شوند.',
  'rec.plan.overDelivered': '{n} جلسه بیش از برنامه ارائه شده — با قیمت فهرست.',
  'rec.plan.owed': '{amount} بدهی',
  'rec.plan.credit': '{amount} اعتبار',
  'rec.plan.settled': 'تسویه‌شده',
  'rec.plan.stillOwed': '{amount} هنوز روی این بسته بدهی است',
  'rec.plan.paymentsSub':
    'از حساب مراجع: آنچه بدهی است، آنچه به‌عنوان اعتبار نگه داشته شده، و خالص — ارقام سامانه مرکز.',
  'rec.det.registration': 'ثبت‌نام',
  'rec.det.registeredOn': 'ثبت‌شده {date}',
  'rec.det.registeredBy': 'توسط {who}',
  'rec.det.createdOn': 'پرونده ساخته‌شده {date}',
  'rec.det.nationalId': 'کد ملی',
  'rec.det.address': 'نشانی',
  'rec.det.referral': 'منبع ارجاع',
  'rec.sectionFailed': 'این بخش بارگذاری نشد. بقیه پرونده سر جایشان هستند.',
  'rec.demographics': 'اطلاعات جمعیتی',
  'rec.caregivers': 'همراهان',
  'rec.historyIntake': 'سابقه و معارفه',
  'rec.adminHistory': 'تاریخچه پرونده',
  'rec.adminHistoryBody':
    'تغییرهای ثبت‌شدهٔ این پرونده — هویت، همراهانِ اضافه‌شده، برداشته‌شده یا اصلاح‌شده، معارفه، بسته‌ها، جلسه‌ها و ابزارهای بالینی — با مقدارهای قبلی. اصلاحیه‌های ارزیابی روی خودِ هر ارزیابی فهرست شده‌اند.',
  'rec.noAssigned':
    'درمانگر تعیین‌شده‌ای نیست: مراجع به مرکز مراجعه می‌کند و هر جلسه درمانگر خودش را دارد.',
  'rec.editCta': 'دیدن و ویرایش',
  'rec.laterPhase': 'طراحی شده در {phase}',
  'rec.assessments': 'ارزیابی‌ها',
  'rec.packages': 'بسته‌ها',
  'rec.bookings': 'نوبت‌ها',
  'rec.sessions': 'جلسات ارائه شده',
  'rec.journey': 'مسیر',
  'rec.payments': 'پرداخت‌ها',
  'rec.addCaregiver': 'افزودن همراه',
  'rec.cgRefused': 'سامانه مرکز این تغییر را نپذیرفت — هیچ‌چیز از آنچه نوشتید از بین نرفت.',
  'rec.cgPrimary': 'تماس اصلی',
  'rec.cgMakePrimary': 'تعیین به‌عنوان تماس اصلی',
  'rec.removeCaregiverTitle': 'این همراه از پرونده برداشته شود؟',
  'rec.removeCaregiverBody':
    'این مورد از استفاده خارج می‌شود اما در تاریخچه پرونده می‌ماند — چیزی حذف نمی‌شود.',
  'rec.historyEmpty': 'هنوز اصلاحی نیست — پرونده همان‌طور که اول نوشته شد باقی است.',
  'rec.hSet': 'تنظیم شد به {value}',
  'rec.hChanged': 'بود {from} — حالا {to}',
  'rec.hf.gender': 'جنسیت',
  'rec.hf.dateOfBirth': 'تاریخ تولد',
  'rec.hf.address': 'نشانی',
  'rec.hf.recordNumber': 'شماره پرونده',
  'rec.hf.firstName': 'نام',
  'rec.hf.lastName': 'نام خانوادگی',
  'rec.hf.contactMobile': 'موبایل تماس اصلی',
  'rec.hf.nationalId': 'کد ملی',
  'rec.hf.absorbedPatientId': 'یک پرونده مهمان در این پرونده ادغام شد',
  'rec.hf.autismIdentified': 'شناسایی اوتیسم',
  'rec.hv.autismYes': 'به‌عنوان اوتیستیک شناسایی‌شده',
  'rec.hv.autismNo': 'به‌عنوان اوتیستیک شناسایی‌نشده',
  'rec.hc.added': 'همراه اضافه شد',
  'rec.hc.removed': 'همراه حذف شد',
  'rec.hc.unreadable': 'یک همراه (جزئیات خواندنی نیست)',
  'rec.hc.f.name': 'نام همراه',
  'rec.hc.f.relationship': 'نسبت همراه',
  'rec.hc.f.relationshipOther': 'نسبت همراه (به زبان خودشان)',
  'rec.hc.f.mobile': 'شماره تماس همراه',
  'rec.hc.f.other': 'جزئیات همراه',
  'rec.hf.differentPersonConfirmed': 'بررسی تکراری',
  'rec.hv.dupDecision':
    'به‌عنوان شخصی متفاوت از {n, plural, one {# پرونده مشابه} other {# پرونده مشابه}} تایید شد — هر دو نگه داشته شدند.',
  'rec.hv.dupSignals': 'مطابقت بر اساس: {signals}.',
  'rec.hv.dupUnreadable': 'یک تصمیم بررسی تکراری (جزئیات خواندنی نیست)',
  'rec.hv.sig.contact_mobile': 'همان شماره تماس',
  'rec.hv.sig.caregiver_mobile': 'شمارهٔ یکی از همراهان',
  'rec.hv.sig.name_dob': 'همان نام و تاریخ تولد',
  'rec.hv.sig.national_id': 'همان کد ملی',

  'path.title': 'اولین ویزیت',
  'path.sub': 'چه کاری انجام‌شده و چه چیزی مانده — هیچ‌چیز شبیه بیمارستان نیست.',
  'path.registration': 'ثبت‌نام',
  'path.registrationDone': 'انجام شد',
  'path.registrationDoneOn': 'انجام شد — {date}',
  'path.registrationPending': 'هنوز تکمیل نشده — قابل‌نوبت‌دهی، نه پروندهٔ درمانی',
  'path.needsRegistration': 'بعد از کامل‌شدن ثبت‌نام باز می‌شود',
  'path.intake': 'معارفه',
  'path.intakeOptional': 'اختیاری — رد کردنش جلوی چیزی را نمی‌گیرد',
  'path.intakeInProgress': 'در جریان',
  'path.intakeDone': 'انجام شد',
  'path.intakeStart': 'شروع معارفه',
  'path.assessment': 'ارزیابی اولیه',
  'path.assessmentDone': 'انجام شد — {date}',
  'path.assessmentPending':
    'ارزیابی اولیه پیشنهاد می‌شود — از تقویم رزرو می‌شود؛ بسته را بدون آن هم می‌شود ساخت.',
  'path.package': 'بسته و جلسات بعدی',
  'path.packageGate':
    'هنوز بسته‌ای نیست — ارزیابی اولیه توصیه می‌شود، اما بسته بدون آن هم ساخته می‌شود.',
  'path.packageOpen': 'هنوز بسته‌ای نیست — می‌توان بسته ساخت.',

  'intake.title': 'معارفه',
  'intake.sub':
    'یک گفتگوی کوتاه و دوستانه، نه یک فرم. اختیاری — هیچ‌وقت جلوی ارزیابی را نمی‌گیرد، چیزی تشخیص نمی‌دهد و بسته‌ای تعیین نمی‌کند.',
  'intake.start': 'شروع معارفه',
  'intake.mode': 'چطور ثبت می‌شود',
  'intake.mode.self_entry': 'خوداظهاری (با همراهی مرکز)',
  'intake.mode.staff_assisted': 'با کمک کارکنان',
  'intake.status.in_progress': 'در جریان',
  'intake.status.completed': 'تکمیل‌شده',
  'intake.contextGoals': 'امید خانواده',
  'intake.contextGoalsHelp': 'به زبان خودشان.',
  'intake.notes': 'یادداشت‌ها',
  'intake.complaints': 'نگرانی‌ها',
  'intake.complaintDesc': 'نگرانی',
  'intake.severity': 'شدت',
  'intake.duration': 'مدت',
  'intake.history': 'تاریخچه مرتبط',
  'intake.historyItem': 'مورد تاریخچه',
  'intake.detail': 'جزئیات',
  'intake.medications': 'داروها',
  'intake.medication': 'دارو',
  'intake.dosage': 'دوز',
  'intake.frequency': 'تناوب',
  'intake.medStatus': 'وضعیت',
  'intake.selfReported': 'خوداظهاری',
  'intake.staffRecorded': 'ثبت‌شده توسط کارکنان',
  'intake.addRow': 'افزودن',
  'intake.removeTitle': 'این سطر حذف شود؟',
  'intake.removeBody':
    'ردیف از معارفه کنار می‌رود و در پرونده می‌ماند که چه کسی و کی آن را برداشت — چیزی حذف نمی‌شود. ردیف‌های اشتباه همین‌طور برداشته می‌شوند.',
  'intake.errCompleted':
    'این معارفه را کس دیگری همین حالا تکمیل کرده بود — صفحه تازه شد. محتوایش همچنان قابل‌اصلاح است.',
  'intake.errGone': 'آن سطر از قبل توسط شخص دیگری حذف‌شده — فهرست به‌روز شد. چیز دیگری تغییر نکرد.',
  'intake.errDupHistory':
    'آن مورد سابقه همین حالا در این معارفه انتخاب شده — به‌جای افزودن دوباره، ردیف موجود را ویرایش کنید.',
  'intake.errRefused':
    'سامانه مرکز این تغییر را نپذیرفت — هیچ‌چیز از آنچه نوشتید از بین نرفت. فیلدها را بررسی کنید و دوباره تلاش کنید.',
  'intake.completeCta': 'ثبت تکمیل معارفه',
  'intake.completeTitle': 'این معارفه تکمیل شود؟',
  'intake.completeBody':
    'کامل کردن یک عمل صریح است. هیچ‌چیز داخلش الزامی نبود، و نسخه‌های اصلی خوداظهاری قابل بازسازی می‌مانند.',
  'intake.completedNote':
    'کامل شد — ارزیابی به آن به‌صورت زنده ارجاع می‌دهد، نه یک کپی. اصلاح همچنان ممکن است؛ هر تغییر با این‌که چه کسی و چه زمانی ثبت می‌شود.',
  'intake.none': 'هنوز معارفه‌ای نیست. رد شدن از آن هیچ‌چیز را قفل نمی‌کند.',
  'intake.open': 'باز کردن',
  /* ── بازطراحی پذیرش (ZOY-574) ─────────────────────────────────────────── */
  'intake.clinicalTitle': 'سوابق پیرامون تولد و گزارش‌های بالینی',
  'intake.clinicalSub':
    'واقعیت‌های دوره تولد و خلاصه گزارش‌ها برای این پذیرش. تاریخ تولد و منبع ارجاع مال پرونده مراجع است و این‌جا برای زمینه نشان داده می‌شوند.',
  'intake.dob': 'تاریخ تولد',
  'intake.dobEstimated': 'تخمینی',
  'intake.referralSource': 'منبع ارجاع',
  'intake.patientOwnedNote': 'در پرونده مراجع ویرایش می‌شود، نه این‌جا.',
  'intake.apgar': 'نمره آپگار',
  'intake.apgarHelp': 'همان‌طور که ثبت‌شده — مثلا ۸/۹.',
  'intake.nicuAdmitted': 'بستری در NICU',
  'intake.nicuDuration': 'مدت بستری در NICU',
  'intake.nicuDurationValue': 'مدت',
  'intake.nicuDurationUnit': 'واحد',
  'intake.nicuUnit.days': 'روز',
  'intake.nicuUnit.weeks': 'هفته',
  'intake.nicuUnit.months': 'ماه',
  'intake.nicuPairErr': 'هم مدت و هم واحدش را بدهید، یا هیچ‌کدام.',
  'intake.nicuValueErr': 'یک عدد کامل وارد کنید.',
  'intake.nicuDetails': 'جزئیات NICU',
  'intake.jaundice': 'زردی نوزادی',
  'intake.jaundiceDetails': 'جزئیات زردی',
  'intake.eegReport': 'گزارش EEG',
  'intake.brainImagingReport': 'گزارش تصویربرداری مغز',
  'intake.metabolicLabReport': 'گزارش آزمایش متابولیک',
  'intake.brainInjuryHistory': 'تاریخچه آسیب مغزی',
  'intake.surgeryHistory': 'تاریخچه جراحی',
  'intake.reportHelp': 'متن آزاد توصیفی — آنچه گزارش می‌گوید، به زبان درمانگر.',
  'intake.yes': 'بله',
  'intake.no': 'خیر',
  'intake.unanswered': 'پاسخ داده نشده',
  'intake.clearAnswer': 'علامت گذاری به‌عنوان پاسخ داده نشده',
  'intake.saved': 'ذخیره شد.',
  /* شکایت‌ها (ZOY-571) */
  'intake.complaintCategory': 'دسته',
  'intake.complaintItem': 'شکایت',
  'intake.complaintOtherText': 'شکایت را توصیف کنید',
  'intake.complaintOtherHelp': 'برای «دیگر» الزامی است — بگویید نگرانی چیست.',
  'intake.pickCategoryFirst': 'اول یک دسته انتخاب کنید.',
  'intake.sev.mild': 'خفیف',
  'intake.sev.moderate': 'متوسط',
  'intake.sev.severe': 'شدید',
  'intake.notesRow': 'یادداشت‌ها',
  'intake.cc.speech_language': 'گفتار و زبان',
  'intake.cc.social_communication': 'ارتباط اجتماعی',
  'intake.cc.behaviour_attention': 'رفتار و توجه',
  'intake.cc.motor': 'حرکتی',
  'intake.cc.sensory': 'حسی',
  'intake.cc.feeding_sleep': 'تغذیه و خواب',
  'intake.cc.learning': 'یادگیری',
  'intake.cc.other': 'سایر',
  'intake.legacyRow': 'ثبت‌شده پیش از فهرست',
  'intake.legacySeverity': 'ثبت‌شده به‌عنوان: {value}',
  /* سوابق (ZOY-570) */
  'intake.hs.medical_condition': 'شرایط پزشکی',
  'intake.hs.developmental_history': 'تاریخچه رشدی / تولد',
  'intake.otherHistory': 'تاریخچه دیگر',
  'intake.otherHistoryNote':
    'پیش از تقسیم تاریخچه به بخش‌ها ثبت‌شده — دقیقا همان‌طور که ذخیره‌شده نشان داده می‌شود.',
  'intake.historyOtherHelp': 'برای «دیگر» الزامی است — بگویید چیست.',
  /* داروها (ZOY-572) */
  'intake.medSource': 'منبع',
  'intake.medFromList': 'از فهرست داروها',
  'intake.medOther': 'در فهرست نیست',
  'intake.medOtherName': 'نام دارو',
  'intake.medCategory': 'دسته',
  'intake.medAllCategories': 'همه دسته‌ها',
  'intake.medSearch': 'جستجوی داروها',
  'intake.medSearchHelp': 'بخشی از نام تجاری یا عمومی را تایپ کنید.',
  'intake.medSearchHint': 'جستجو کنید، یا یک دسته انتخاب کنید تا داروها را ببینید.',
  'intake.medNoResults': 'چیزی مطابقت ندارد.',
  'intake.medPicked': 'انتخاب‌شده',
  'intake.medChange': 'تغییر',
  'intake.timeframe': 'بازه زمانی',
  'intake.tf.current': 'فعلی',
  'intake.tf.historical': 'گذشته',
  'intake.tf.unspecified': 'نامشخص',
  'intake.timeframeNeeded': 'فعلی یا گذشته را انتخاب کنید.',
  'intake.medSourceNeeded': 'یک دارو از فهرست انتخاب کنید، یا نامش را بنویسید.',
  'intake.reason': 'دلیل',
  'intake.prescriber': 'تجویزکننده',
  'intake.startOn': 'شروع',
  'intake.endOn': 'پایان',
  'intake.year': 'سال',
  'intake.month': 'ماه',
  'intake.dateHelp': 'تقریبی — سال، یا سال و ماه.',
  'intake.endOnlyPast': 'تاریخ پایان فقط برای داروی گذشته اعمال می‌شود.',
  'intake.legacyStatus': 'وضعیت ثبت‌شده: {value}',
  /* رد شدن‌های تایپ‌شده */
  'intake.errOtherDetail': 'برای «دیگر»، متن الزامی است.',
  'intake.errDescNotAllowed': 'مورد فهرست نام خودش را دارد — متن آزاد فقط برای «دیگر» است.',
  'intake.errUnavailable':
    'آن مورد دیگر برای موارد جدید در دسترس نیست. پرونده‌های موجود آن را نگه می‌دارند — مورد دیگری انتخاب کنید.',
  'intake.errMedDate': 'این تاریخ تقویمی واقعی نیست.',
  'intake.errMedEnd': 'فقط داروی گذشته می‌تواند تاریخ پایان داشته باشد.',
  'intake.errMedOrder': 'پایان نباید پیش از شروع باشد.',
  'intake.errMedSource': 'دقیقا یکی بدهید: یک دارو از فهرست، یا یک نام.',
  /* دسته‌های دارویی — فهرست اصلی داروها (ZOY-572) */
  'intake.mc.anticonvulsant': 'ضدتشنج',
  'intake.mc.antipsychotic': 'ضدروان‌پریشی',
  'intake.mc.antidepressant': 'ضدافسردگی',
  'intake.mc.stimulant': 'محرک‌ها (ADHD)',
  'intake.mc.non_stimulant_adhd': 'ADHD غیرمحرک',
  'intake.mc.anxiolytic_sedative': 'ضداضطراب و آرام‌بخش',
  'intake.mc.gastrointestinal': 'گوارشی',
  'intake.mc.allergy_respiratory': 'آلرژی و تنفسی',
  'intake.mc.antibiotic': 'آنتی‌بیوتیک',
  'intake.mc.supplement': 'مکمل‌ها',
  'intake.mc.probiotic': 'پروبیوتیک',
  'intake.mc.other': 'سایر',

  /* ── پیوست‌های معارفه (ZOY-705) ────────────────────────────────────── */
  'intake.att.title': 'پیوست‌ها',
  'intake.att.count': '{n, number} از {max, number}',
  'intake.att.limits':
    'PDF، PNG، JPEG یا WebP · هر فایل حداکثر {mb} مگابایت · حداکثر {max, number} پیوست برای هر معارفه. هر فایل پس از بارگذاری می‌تواند توضیحات خودش را داشته باشد.',
  'intake.att.add': 'افزودن فایل‌ها',
  'intake.att.full': 'این معارفه به سقف پیوست‌ها رسیده — برای افزودن، یکی را بردارید.',
  'intake.att.skipped':
    '{n, plural, one {# فایل افزوده نشد} other {# فایل افزوده نشدند}} — هر معارفه حداکثر {max, number} پیوست دارد.',
  'intake.att.empty': 'هنوز پیوستی نیست.',
  'intake.att.unnamed': 'فایل بی‌نام',
  'intake.att.addedBy': 'اضافه‌شده توسط {name}',
  'intake.att.kind.pdf': 'PDF',
  'intake.att.kind.png': 'PNG',
  'intake.att.kind.jpeg': 'JPEG',
  'intake.att.kind.webp': 'WebP',
  'intake.att.kind.file': 'فایل',
  'intake.att.open': 'باز کردن',
  'intake.att.describe': 'افزودن توضیح',
  'intake.att.editDesc': 'ویرایش توضیح',
  'intake.att.noDesc': 'بدون توضیح.',
  'intake.att.descLabel': 'توضیحات',
  'intake.att.descHelp': 'اختیاری — این سند چیست، حداکثر {max, number} نویسه.',
  'intake.att.descTooLong': 'خیلی طولانی است — توضیح را کوتاه کنید.',
  'intake.att.descSave': 'ذخیره توضیح',
  'intake.att.removeTitle': 'این پیوست حذف شود؟',
  'intake.att.removeBody':
    '«{name}» از معارفه کنار می‌رود و در پرونده می‌ماند که چه کسی و کی آن را برداشت. خود فایل بعداً حذف می‌شود.',
  'intake.att.removeReason': 'دلیل (اختیاری)',
  'intake.att.uploadingChip': 'در حال بارگذاری',
  'intake.att.failedChip': 'اضافه نشد',
  'intake.att.queued': 'در انتظار…',
  'intake.att.declaring': 'در حال آماده‌سازی…',
  'intake.att.uploading': 'در حال بارگذاری… {pct, number}%',
  'intake.att.completing': 'در حال اتمام…',
  'intake.att.retry': 'تلاش دوباره',
  'intake.att.dismiss': 'بستن',
  'intake.att.errType': 'فقط فایل‌های PDF، PNG، JPEG یا WebP می‌توانند پیوست شوند.',
  'intake.att.errSize': 'این فایل از حد ۱۰ مگابایت بزرگ‌تر است.',
  'intake.att.errLimit': 'این معارفه به سقف پیوست‌ها رسیده است.',
  'intake.att.errContent': 'نوع محتوای فایل پذیرفته نمی‌شود، بنابراین نگه داشته نشد.',
  'intake.att.errState': 'این پیوست دیگر در وضعیتی نیست که این کار را اجازه دهد — صفحه به‌روز شد.',
  'intake.att.errGone': 'آن پیوست از قبل توسط شخص دیگری حذف‌شده — فهرست به‌روز شد.',
  'intake.att.errStorage': 'همین حالا به فضای ذخیره‌سازی دسترسی نبود — کمی بعد دوباره تلاش کنید.',
  'intake.att.errUpload': 'فایل به فضای ذخیره‌سازی فرستاده نشد — دوباره تلاش کنید.',
  'intake.att.cardCount': '{n, plural, one {# پیوست} other {# پیوست}}',

  /* ── شماره‌های بیمار (ZOY-705) ─────────────────────────────────────── */
  'ptForm.homePhone': 'شماره منزل',
  'ptForm.altPhone': 'شماره اضافی',
  'ptForm.phoneOptionalHelp': 'اختیاری — راه دیگری برای تماس با خانواده.',
  'ptForm.mobileNotCanonical':
    'این شماره به‌عنوان شماره تلفن خوانده نشد — با کد منطقه واردش کنید، مثلا ۰۲۱… یا ۰۹۱۲….',
  'rec.sum.homePhone': 'شماره منزل',
  'rec.sum.altPhone': 'شماره اضافی',
  'res.signal.home_phone': 'شماره منزل',
  'res.signal.alt_phone': 'شماره اضافی',
  'res.signal.other': 'با این پرونده مطابقت داشت',
  'pt.fPhoneKind.contactMobile': 'موبایل تماس',
  'pt.fPhoneKind.homePhone': 'شماره منزل',
  'pt.fPhoneKind.altPhone': 'شماره اضافی',
  'pt.chipPhoneVia': 'تلفن: {q} · با {kind} مطابقت داشت',
};
